import React, { useEffect, useState } from "react";
import {
  Body,
  Container,
  PaginationWrapper,
  ViewCard,
  ViewList,
  Wrapper,
  Modal,
  HeaderInfo,
  ViewCardContent,
  CardContent,
  CardTitle,
  Description,
  CardMeta,
  SkillsList,
  Skill,
  MetaItem,
} from "../style/view.styles";
import Pagination from "../components/Elements/Pagination";
import { fetchEntityData } from "../utils/RequestHandler";
import LoadingSpinner from "../components/Elements/LoadingSpinner";
import EmptyState from "../components/Elements/EmptyState";
import MentorshipApplicationForm from "../components/Elements/MentorshipApplicationForm";
import FilterSidebar from "../components/Elements/FilterSidebar";
import { useNavigate } from "react-router-dom";

const filters = [
  {
    filter: "Expertise",
    options: ["Software Engineering", "Accounting"],
  },
];

export default function Mentors() {
  const [filteredMentors, setFilteredMentors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const recordsPerPage = 9;

  useEffect(() => {
    const checkUserLoggedIn = async () => {
      const user = localStorage.getItem("user");
      setIsLoggedIn(!!user);
      if (user) {
        setIsLoggedIn(true);
        const parsedUser = JSON.parse(user);
        setUserRole(parsedUser.role);
        setUser(parsedUser);
      } else {
        setIsLoggedIn(false);
        setUserRole(null);
      }
    };

    const fetchMentors = async () => {
      try {
        const data = await fetchEntityData("mentors");
        if (data.success) {
          setFilteredMentors(data.result);
        }
      } catch (error) {
        console.error("Failed to fetch mentors:", error);
      } finally {
        setLoading(false);
      }
    };
    checkUserLoggedIn();
    fetchMentors();
  }, [isLoggedIn, user?.username, userRole]);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredMentors.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const handlePageChange = (page) => setCurrentPage(page);

  const handleModalClose = () => setIsModalOpen(false);

  const handleClickMentor = (mentor) => {
    setSelectedMentor(mentor);
    navigate("/mentors-detail", {
      state: { mentor },
    });
  };
  return (
    <>
      <Wrapper className="paleBlueGreyBg">
        <Container>
          {/* Sidebar Section */}
          <FilterSidebar filters={filters} />
          {/* Body Section */}
          <Body>
            <HeaderInfo>
              <h1 className="font30 darkGreenColor extraBold">
                Available Mentors
              </h1>
            </HeaderInfo>
            {loading && <LoadingSpinner message="Loading mentors" />}
            {!loading && filteredMentors.length === 0 && (
              <EmptyState message={"No mentors available."} />
            )}
            {!loading && filteredMentors.length > 0 && (
              <ViewList>
                {currentRecords.map((record, index) => (
                  <ViewCard
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClickMentor(record);
                    }}
                  >
                    <ViewCardContent>
                      <CardContent>
                        <CardTitle>{`${record.fullname}`}</CardTitle>
                        <Description>
                          {`${record.bio.slice(0, 50)}${
                            record.bio.length > 50 ? "..." : ""
                          }`}
                        </Description>
                        <CardMeta>
                          <MetaItem>
                            <SkillsList>
                              {record.specializations
                                .split(",")
                                .map((specialization, index) => (
                                  <Skill key={index}>
                                    {specialization.trim()}
                                  </Skill>
                                ))}
                            </SkillsList>
                          </MetaItem>
                        </CardMeta>
                      </CardContent>
                    </ViewCardContent>
                  </ViewCard>
                ))}
              </ViewList>
            )}
            {filteredMentors.length > recordsPerPage && (
              <PaginationWrapper>
                <Pagination
                  totalItems={filteredMentors.length}
                  itemsPerPage={recordsPerPage}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </PaginationWrapper>
            )}
          </Body>
        </Container>
      </Wrapper>
      {isModalOpen && (
        <Modal>
          <MentorshipApplicationForm
            handleModalClose={handleModalClose}
            selectedMentor={selectedMentor}
          />
        </Modal>
      )}
    </>
  );
}
